

export  enum ItemType {
  A_COURS,
  A_STUDENT,
  A_CATEGORY,
  CATEGORY,
  COURS,
  STUDENT,
  CATEGORY_EDIT,
  COURS_EDIT,
  STUDENT_EDIT,
  CATEGORY_DEL,
  COURS_DEL,
  STUDENT_DEL
}
